"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var createContainer_1 = tslib_1.__importDefault(require("./createContainer"));
var Lifetime_1 = tslib_1.__importDefault(require("./constants/Lifetime"));
var registrations_1 = tslib_1.__importDefault(require("./registrations"));
exports.default = tslib_1.__assign({ createContainer: createContainer_1.default,
    Lifetime: Lifetime_1.default }, registrations_1.default);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/core/dependency-container/index.js
// module id = 20
// module chunks = 0